module.exports = __webpack_public_path__ + "img/meta.b648ef49.svg";